import { ButtonBase, alpha, styled } from '@mui/material';
import { spaceCadet } from '../../../../../utils/colors';

const StyledButton = styled(ButtonBase)(({ theme }) => ({
  color: spaceCadet[100],
  fontSize: 14,
  lineHeight: '20px',
  padding: '8px 12px',
  fontWeight: 600,
  maxWidth: 200,
  '& > div': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-start',
    flexGrow: 1,
  },

  '&:hover': {
    backgroundColor: alpha('#000', 0.25),
  },
  borderRadius: 4,
  '& svg': {
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.standard,
    }),
    transform: 'rotate(0deg)',
  },
  '&.active': {
    backgroundColor: alpha('#000', 0.4),
    '&:hover': {
      backgroundColor: alpha('#000', 0.55),
    },
    '& svg': {
      transform: 'rotate(180deg)',
    },
  },
}));

export default StyledButton;
